'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Patent = require('../entity').Patent;

module.exports = function (connection) {
  return {
    byOrganisationseinheitEquals: function byOrganisationseinheitEquals(organisationseinheit, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byOrganisationseinheitEquals', 'organisationseinheit')(organisationseinheit, additionalParams);
    },
    byLinkLike: function byLinkLike(link, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byLinkLike', 'link')(link, additionalParams);
    },
    byLandEquals: function byLandEquals(land, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byLandEquals', 'land')(land, additionalParams);
    },
    byTitelEquals: function byTitelEquals(titel, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byTitelEquals', 'titel')(titel, additionalParams);
    },
    findOne: function findOne(projection, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'findOne', 'projection')(projection, additionalParams);
    },
    byKurzbeschreibungLike: function byKurzbeschreibungLike(kurzbeschreibung, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byKurzbeschreibungLike', 'kurzbeschreibung')(kurzbeschreibung, additionalParams);
    },
    byKurzbeschreibungEquals: function byKurzbeschreibungEquals(kurzbeschreibung, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byKurzbeschreibungEquals', 'kurzbeschreibung')(kurzbeschreibung, additionalParams);
    },
    byTitelLike: function byTitelLike(titel, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byTitelLike', 'titel')(titel, additionalParams);
    },
    findAll: function findAll(page, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'findAll', 'page')(page, additionalParams);
    },
    byVeroeffentlichungsnummerLike: function byVeroeffentlichungsnummerLike(veroeffentlichungsnummer, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byVeroeffentlichungsnummerLike', 'veroeffentlichungsnummer')(veroeffentlichungsnummer, additionalParams);
    },
    byLizenzenEquals: function byLizenzenEquals(lizenzen, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byLizenzenEquals', 'lizenzen')(lizenzen, additionalParams);
    },
    byLizenzenLike: function byLizenzenLike(lizenzen, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byLizenzenLike', 'lizenzen')(lizenzen, additionalParams);
    },
    byAnsprechpartnerEquals: function byAnsprechpartnerEquals(ansprechpartner, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byAnsprechpartnerEquals', 'ansprechpartner')(ansprechpartner, additionalParams);
    },
    byLinkEquals: function byLinkEquals(link, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byLinkEquals', 'link')(link, additionalParams);
    },
    byVeroeffentlichungsnummerEquals: function byVeroeffentlichungsnummerEquals(veroeffentlichungsnummer, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byVeroeffentlichungsnummerEquals', 'veroeffentlichungsnummer')(veroeffentlichungsnummer, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byHaupterfinderEquals: function byHaupterfinderEquals(haupterfinder, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byHaupterfinderEquals', 'haupterfinder')(haupterfinder, additionalParams);
    },
    byForschungsgebietLike: function byForschungsgebietLike(forschungsgebiet, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byForschungsgebietLike', 'forschungsgebiet')(forschungsgebiet, additionalParams);
    },
    byForschungsgebietEquals: function byForschungsgebietEquals(forschungsgebiet, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'byForschungsgebietEquals', 'forschungsgebiet')(forschungsgebiet, additionalParams);
    },
    forForschungsbericht: function forForschungsbericht(orgaid, additionalParams) {
      return templates.searchTemplate(connection)(Patent, 'forForschungsbericht', 'orgaid')(orgaid, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Patent, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('patent')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/patent.js
// module id = eiIE
// module chunks = 0